/**
 * @file Input types registry - exports all available input types
 * @version 1.0.0
 */

import { StringInputType } from './string.js';
import { EmailInputType } from './email.js';
import { UrlInputType } from './url.js';
import { PasswordInputType } from './password.js';
import { TextareaInputType } from './textarea.js';
import { NumberInputType } from './number.js';
import { BooleanInputType } from './boolean.js';
import { EnumInputType } from './enum.js';
import { DateInputType } from './date.js';
import { DateTimeInputType } from './datetime.js';
import { ColorInputType } from './color.js';

/**
 * Default input types registry
 * Order matters: more specific types should come before more general ones
 */
export const INPUT_TYPES = [
  PasswordInputType,
  EmailInputType,
  UrlInputType,
  ColorInputType,
  DateTimeInputType,
  DateInputType,
  TextareaInputType,
  NumberInputType,
  BooleanInputType,
  EnumInputType,
  StringInputType, // Must be last as fallback
];

/**
 * Named exports for easy access and extension
 */
export {
  StringInputType,
  EmailInputType,
  UrlInputType,
  PasswordInputType,
  TextareaInputType,
  NumberInputType,
  BooleanInputType,
  EnumInputType,
  DateInputType,
  DateTimeInputType,
  ColorInputType,
};

/**
 * Get input type by name
 * @param {string} name - The input type name
 * @returns {object | null} The input type definition or null if not found
 */
export function getInputTypeByName(name) {
  return INPUT_TYPES.find(type => type.name === name) || null;
}

/**
 * Register a new input type
 * @param {object} inputType - The input type definition
 * @param {number} index - Optional index to insert at (defaults to before StringInputType)
 */
export function registerInputType(inputType, index = INPUT_TYPES.length - 1) {
  INPUT_TYPES.splice(index, 0, inputType);
}

export default INPUT_TYPES;
